export const FETCH_ALLNOTICE_REQUEST = 'FETCH_ALLNOTICE_REQUEST'
export const FETCH_ALLNOTICE_SUCCESS = 'FETCH_ALLNOTICE_SUCCESS'
export const FETCH_ALLNOTICE_ADDED_SUCCESS = 'FETCH_ALLNOTICE_ADDED_SUCCESS'
export const FETCH_ALLNOTICE_FALIURE = 'FETCH_ALLNOTICE_FALIURE'
